<template>
  <span class="ym-price"
        :class="[
          `ym-price-size-${size}`,
          `ym-price-type-${type}`,
          { 'is-del': del },
          { 'is-string': !isNumber },
        ]"
  ><slot></slot><span v-html="html"></span></span>
</template>

<script>
  import { formatPriceHtml } from '@/utils';

  export default {
    name: 'YmPrice',
    props: {
      price: {
        type: [Number, String],
        required: true,
      },
      size: {
        type: String,
        validator(val) {
          return ['extra-small', 'small', 'medium', 'normal', 'large'].includes(val);
        },
        default: 'normal',
      },
      type: {
        type: String,
        validator(val) {
          return [
            'highlight',
            'primary',
            'primary-bar',
            'base',
            'light',
            'gold',
            'black',
          ].includes(val);
        },
        default: 'highlight',
      },
      del: {
        type: Boolean,
        default: false,
      },
      formatFree: {
        type: Boolean,
        default: true,
      },
      addUnit: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      html() {
        return formatPriceHtml(this.price, this.formatFree, this.addUnit);
      },
      isNumber() {
        if (!this.formatFree) return true;
        return Number(this.price) !== 0;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .ym-price {
    display: inline-flex;
    align-items: flex-end;
    position: relative;

    /deep/ .price-unit {
      margin-right: @size-extra-small / 2;
    }

    &.is-del {
      color: @price-color-delete;
      font-weight: @font-weight-primary;
      /deep/ .price-unit {
        line-height: 1;
        font-weight: @font-weight-primary;
      }
      &::after {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: -@price-del-pad-size;
        right: -@price-del-pad-size;
        height: 1px;
        background-color: @price-color-delete;
      }
    }

    &-type-highlight {
      color: @price-color-highlight;
    }

    &-type-primary {
      color: @price-color-primary;
    }

    &-type-primary-bar {
      color: @color-white;
      &.is-del {
        color: inherit;
        &::after {
          background-color: @color-white;
        }
      }
    }

    &-type-base {
      color: @color-text-base;
    }

    &-type-light {
      color: @color-text-lighter;
    }

    &-type-gold {
      color: @color-text-gold;
      &.is-del {
        color: @color-text-gold;
        &::after {
          background-color: @color-text-gold;
        }
      }
    }

    &-type-black {
      color: @color-text-base;
    }

    &-size-extra-small {
      line-height: 1;
      font-size: @font-size-extra-extra-small;
      font-weight: @font-weight-primary;
      /deep/ .price-unit {
        line-height: 1;
        font-size: @font-size-extra-extra-small;
        font-weight: @font-weight-primary;
      }
      &.is-del {
        font-size: @font-size-extra-extra-small;
        /deep/ .price-unit {
          font-size: @font-size-extra-extra-small;
        }
      }
    }

    &-size-small {
      line-height: 1;
      font-size: @font-size-base;
      font-weight: @font-weight-primary;
      /deep/ .price-unit {
        line-height: 1;
        font-size: @font-size-base;
        font-weight: @font-weight-primary;
      }
      &.is-del {
        font-size: @font-size-extra-small;
        /deep/ .price-unit {
          font-size: @font-size-extra-small;
        }
      }
    }

    &-size-normal {
      line-height: 1;
      font-size: @font-size-large;
      font-weight: @font-weight-primary;
      /deep/ .price-unit {
        line-height: 1.2;
        font-size: @font-size-extra-small;
        font-weight: @font-weight-primary;
      }
      &.is-del {
        font-size: @font-size-extra-small;
      }
    }

    &-size-medium {
      line-height: 1;
      font-size: @font-size-medium;
      font-weight: @font-weight-primary;
      /deep/ .price-unit {
        line-height: 1;
        font-size: @font-size-small;
        font-weight: @font-weight-primary;
      }
      &.is-del {
        font-size: @font-size-extra-small;
      }
    }

    &-size-large {
      line-height: 1;
      font-size: @font-size-extra-extra-large;
      font-weight: @font-weight-primary;
      /deep/ .price-unit {
        line-height: 1.2;
        font-size: @font-size-base;
        font-weight: @font-weight-primary;
      }
      &.is-del {
        font-size: @font-size-base;
      }
    }

    &.is-string {
      line-height: 1.2;
      &.price-size-small {
        font-size: (@font-size-base - 4);
      }
      &.price-size-normal {
        font-size: (@font-size-large - 4);
      }
      &.price-size-medium {
        font-size: (@font-size-medium - 4);
      }
      &.price-size-large {
        font-size: (@font-size-extra-extra-large - 4);
      }
    }
  }
</style>
